import { NgForOf, NgTemplateOutlet } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormGroup } from "@angular/forms";
import { Observable } from "rxjs";
import { FullProjectHash } from "../../../../_models/project.interface";
import { CreateStatusAttributes } from "../../../../_models/status.interface";
import { ProjectService } from "../../../../_services";
import { FormModalComponent } from "../form-modal-component.class";

@Component({
  selector: "hawk-edit-status-modal",
  imports: [FormsModule, ReactiveFormsModule, NgForOf],
  templateUrl: "./edit-status-modal.component.html",
  standalone: true,
  styleUrls: ["./edit-status-modal.component.scss"],
})
export class EditStatusModalComponent extends FormModalComponent<CreateStatusAttributes, FullProjectHash> {
  @Input() project: FullProjectHash;

  @Input() override formGroup: UntypedFormGroup;
  @Output() override closeModal: EventEmitter<void> = new EventEmitter<void>();
  @Output() override newDBOutput: EventEmitter<FullProjectHash> = new EventEmitter<FullProjectHash>();

  constructor(private projectService: ProjectService) {
    super();
  }

  override formGroupToDBInput(): CreateStatusAttributes {
    return {
      id: this.formGroup.controls["id"].value,
      name: this.formGroup.controls["name"].value,
      closed: this.formGroup.controls["closed"].value,
      report_closed: this.formGroup.controls["report_closed"].value,
      canceled: this.formGroup.controls["canceled"].value,
      color: this.formGroup.controls["color"].value,
      email: this.formGroup.controls["email"].value,
      fixer_forbidden: this.formGroup.controls["fixer_forbidden"].value,
      project_id: this.formGroup.controls["project_id"].value,
      mail_template_id: this.formGroup.controls["mail_template_id"].value,
      task_ids: this.formGroup.controls["task_ids"].value,
    };
  }

  override getDBCallObservable(create_status_attributes: CreateStatusAttributes): Observable<FullProjectHash> {
    return this.projectService.updateProjectStatus(
      create_status_attributes.project_id,
      create_status_attributes.id,
      create_status_attributes,
    );
  }
}
